var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgVolume(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "volume_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "volume_svg__st0",
    d: "M8.4 4.2l-3 2.7c-.5.3-1.3.6-1.8.6H1c-.6 0-1 .5-1 1v3c0 .6.5 1 1 1h2.5c.6 0 1.4.3 1.8.7l3 2.7c.4.4.8.2.8-.3v-11c0-.7-.3-.8-.7-.4zM13.9 3.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7 1.7 1.6 2.6 3.8 2.6 6.1s-.9 4.5-2.6 6.1c-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1 1.9-1.8 2.9-4.3 2.9-6.9s-1.2-4.8-3-6.7z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    className: "volume_svg__st0",
    d: "M11.8 5.7c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7 2 2 2 5.3 0 7.3-.2.2-.2.5 0 .7.1.1.2.1.4.1s.3 0 .4-.1c2.4-2.5 2.4-6.4-.1-8.7zM15.9.1c-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7 5.1 5 5.1 13.2 0 18.3-.2.2-.2.5 0 .7.1.1.2.1.4.1.1 0 .3 0 .4-.1 5.4-5.4 5.4-14.2-.1-19.7z"
  })));
}
export default SvgVolume;